import type { Routes } from '@angular/router';

import type { AggregatedClientsRouteData } from '#modules/clients/models/aggregated-clients.interfaces';

export const CLIENTS_ROUTES: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'list',
            },
            {
                path: 'list',
                loadComponent: () =>
                    import('#modules/clients/layouts/clients-layout/clients-layout.component').then((m) => m.ClientsLayoutComponent),
                data: { isFrom: 'restaurant' } satisfies AggregatedClientsRouteData,
            },
        ],
    },
];
